import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSocket } from '../lib/socket';
import { t, useLocale } from '../i18n';

export default function Lobby() {
    useLocale(); // rerender on locale change
    const navigate = useNavigate();
    const socketRef = useRef(getSocket());

    // Create
    const [title, setTitle] = useState('');
    const [deckId, setDeckId] = useState('modified');

    // Join
    const [joinInput, setJoinInput] = useState('');

    // ID aus Link oder Freitext extrahieren
    function extractRoomId(input: string): string | null {
        const s = input.trim();
        if (!s) return null;
        // 1) vollständiger Link mit .../r/<id>
        const m = RegExp(/\/r\/([^/?#]+)/).exec(s);
        if (m?.[1]) return decodeURIComponent(m[1]);
        // 2) nur die ID
        if (/^[A-Za-z0-9_-]{5,}$/.test(s)) return s;
        return null;
    }

    function onCreate(e: React.FormEvent) {
        e.preventDefault();
        const t = title.trim();

        socketRef.current.emit('create_room', { title: t || undefined, deckId }, (res: { roomId: string }) => {
            navigate(`/r/${encodeURIComponent(res.roomId)}`);
        });
    }

    function onJoin(e: React.FormEvent) {
        e.preventDefault();
        const id = extractRoomId(joinInput);
        if (!id) {
            alert(t('lobby.join.invalid'));
            return;
        }
        navigate(`/r/${encodeURIComponent(id)}`);
    }

    return (
        <div className="max-w-3xl mx-auto grid md:grid-cols-2 gap-6">
            {/* Create */}
            <div className="card p-6">
                <h2 className="text-xl font-semibold mb-2">{t('lobby.create.title')}</h2>
                <p className="text-slate-600 mb-4">{t('lobby.create.desc')}</p>
                <form onSubmit={onCreate} className="space-y-4">
                    <div>
                        <label className="label" htmlFor="room-title">{t('lobby.create.label')}</label>
                        <input id="room-title" className="input w-full" placeholder={t('lobby.create.placeholder')} value={title} onChange={e => setTitle(e.target.value)} />
                    </div>
                    <div>
                        <label className="label" htmlFor="deck-select">{t('lobby.create.deck.label')}</label>
                        <select id="deck-select" className="input w-full" value={deckId} onChange={e => setDeckId(e.target.value)}>
                            <option value="modified">{t('deck.modified')}</option>
                            <option value="fibonacci">{t('deck.fibonacci')}</option>
                            <option value="tshirt">{t('deck.tshirt')}</option>
                        </select>
                    </div>
                    <div className="flex gap-3">
                        <button className="btn-primary" type="submit">{t('lobby.create.button')}</button>
                    </div>
                </form>
            </div>

            {/* Join */}
            <div className="card p-6">
                <h2 className="text-xl font-semibold mb-2">{t('lobby.join.title')}</h2>
                <p className="text-slate-600 mb-4">{t('lobby.join.desc')}</p>
                <form onSubmit={onJoin} className="space-y-4">
                    <div>
                        <label className="label" htmlFor="room-join-input">{t('lobby.join.label')}</label>
                        <input id="room-join-input" className="input w-full" placeholder={t('lobby.join.placeholder')} value={joinInput} onChange={e => setJoinInput(e.target.value)} />
                    </div>
                    <div className="flex gap-3">
                        <button className="btn-primary" type="submit">{t('lobby.join.button')}</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
